// extracted by mini-css-extract-plugin
export default {"mainTableDef":"tableIO_mainTableDef__jEcHT","tableIO_main":"tableIO_tableIO_main__q3sd3","rowInput":"tableIO_rowInput__sPp7m","asyncButton":"tableIO_asyncButton__4R69Q"};